import { render, staticRenderFns } from "./SeeBindLicenses.vue?vue&type=template&id=622403c2&scoped=true&"
import script from "./SeeBindLicenses.vue?vue&type=script&lang=ts&"
export * from "./SeeBindLicenses.vue?vue&type=script&lang=ts&"
import style0 from "./SeeBindLicenses.vue?vue&type=style&index=0&id=622403c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622403c2",
  null
  
)

export default component.exports